import { render, staticRenderFns } from "./GoodsListJmc.vue?vue&type=template&id=067bffea&scoped=true"
import script from "./GoodsListJmc.vue?vue&type=script&lang=js"
export * from "./GoodsListJmc.vue?vue&type=script&lang=js"
import style0 from "./GoodsListJmc.vue?vue&type=style&index=0&id=067bffea&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067bffea",
  null
  
)

export default component.exports